import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

interface CompletionRateChartProps {
  completionRate: number | string;
}

/**
 * Component for displaying a pie chart of completion rate
 */
const CompletionRateChart: React.FC<CompletionRateChartProps> = ({
  completionRate
}) => {
  // Convert completion rate to a number and handle comma decimal separator
  const rate = typeof completionRate === 'string' 
    ? parseFloat(completionRate.replace(',', '.')) 
    : completionRate;
  
  // Get CSS variables for consistent colors
  const getComputedStyle = window.getComputedStyle(document.documentElement);
  const primaryColor = getComputedStyle.getPropertyValue('--color-primary-main').trim() || '#098ac8'; // Accent color
  const textPrimaryColor = getComputedStyle.getPropertyValue('--color-text-primary').trim() || '#ffffff';
  
  // Calculate remaining percentage
  const remaining = 100 - rate;
  
  // Prepare data for the pie chart
  const data = [
    { name: 'Completed', value: rate, color: primaryColor },
    { name: 'Remaining', value: remaining, color: textPrimaryColor }
  ];

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            startAngle={90}
            endAngle={-270}
            labelLine={false}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
            label={false} // Remove percentage label
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip 
            formatter={(value: number) => [`${value.toFixed(1)}%`, '']}
          />
          <Legend 
            payload={
              data.map(item => ({
                value: item.name,
                type: 'circle',
                id: item.name,
                color: item.color
              }))
            }
            layout="horizontal"
            verticalAlign="bottom"
            align="center"
            wrapperStyle={{ 
              paddingTop: '10px',
              position: 'relative',
              marginTop: '-30px'
            }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CompletionRateChart;
